import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Button from "@material-ui/core/Button";
import { Link, useHistory } from "react-router-dom";
import FormControl from "@material-ui/core/FormControl";
import { FormGroup } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  sign: {
    ["@media (min-width:1024px)"]: {
      backgroundColor: "rgb(252, 255, 255)",
      border: "1px solid #00cccc",
      borderRadius: 4,
      padding: 20,
      marginTop: 10,
    },
  },
  logo: {
    width: "40%",
  },
  title: {
    textTransform: "uppercase",
    fontWeight: "400",
    marginBottom: "20px",
  },
  username: {
    marginBottom: "10px",
  },
  signBtn: {
    color: "white",
    backgroundColor: "#6200ee",
    marginTop: "30px",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "#6200ee",
    },
  },
  signQ: {
    color: "grey",
  },
  signLink: {
    textDecoration: "none",
  },
}));

export default function SignUp() {
  const classes = useStyles();
  const history = useHistory();

  const [values, setValues] = useState({
    userName: "",
    password: "",
    showPassword: false,
  });

  const [errorMessage, setErrorMessage] = useState(false);

  console.log(values);
  const handleUserNameChange = (event) => {
    setValues({ ...values, userName: event.target.value });
  };

  const handlePasswordChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const passwordValidation = () => {
    if (values.password.length < 8) {
      setErrorMessage("Your password must be at least 8 characters");
    } else if (values.password.length > 32) {
      setErrorMessage("Your password must be less than 32 characters");
    } else if (!/[(!@#$%^&*)]/.test(values.password)) {
      setErrorMessage(
        "Your password must contain at least one of this characters (!@#$%^&*)"
      );
    } else {
      setErrorMessage("");
    }
  };

  const onSubmit = (event) => {
    event.preventDefault();

    if (errorMessage == false) {
      history.push("/wizardstepone");
    }
  };

  return (
    <div className={classes.sign}>
      <img
        className={classes.logo}
        src={require("../images/logo-text.png").default}
        alt="logo"
      />
      <Typography variant="h3" className={classes.title}>
        Sign Up
      </Typography>
      <form onSubmit={onSubmit}>
        <FormGroup>
          <FormControl>
            <TextField
              className={classes.username}
              type="email"
              id="outlined-basic"
              label="Username"
              variant="outlined"
              value={values.userName}
              required
              onChange={handleUserNameChange}
            />
          </FormControl>
          <FormControl variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">
              Password
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={values.showPassword ? "text" : "password"}
              value={values.password}
              required
              onChange={handlePasswordChange("password")}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {values.showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              labelWidth={70}
            />
            <small
              style={{
                color: "red",
              }}
            >
              {errorMessage}
            </small>
          </FormControl>
        </FormGroup>
        <Button
          className={classes.signBtn}
          type="submit"
          variant="contained"
          disabled={values.userName === "" || values.password === ""}
          onClick={passwordValidation}
        >
          Sign up
        </Button>
      </form>
      <p className={classes.signQ}>Already have account?</p>
      <Link to="/" className={classes.signLink}>
        Sign in please.
      </Link>
    </div>
  );
}
